import PropTypes from 'prop-types';
import React from 'react';
import { useGlobalLayout } from '$contexts/global-layout';
import { useLocale } from '$contexts/locale.jsx';

import {
    IconArrowDown,
    IconArrowUp,
} from '$partials/icons/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const HeaderLink = ({
    index,
    linkItem
}) => {
    const { headerOpen, setHeaderOpen } = useGlobalLayout();

    const { formatURI } = useLocale();

    const url = linkItem?.collection?.__typename === 'BvaBusinessContactListingPage' ? formatURI('contact') : formatURI(linkItem?.collection?.slug);

    return (
        linkItem?.dropdown ? (
            <li className='group inline-block mr-10 last:mr-0 relative'>
                <button
                    className='flex gap-10 cursor-pointer items-center'
                    onClick={() => setHeaderOpen(headerOpen !== index ? index : false)}
                    type='button'>
                    <span className='type-style-7'>
                        {linkItem?.title}
                    </span>

                    {headerOpen === index ? <IconArrowUp colour='currentColor' /> : <IconArrowDown colour='currentColor' />}
                </button>
            </li>
        ) : (
            <li className='group inline-block mr-10 last:mr-0 relative'>
                <a
                    className='flex gap-10 cursor-pointer'
                    href={url}>
                    <span className='type-style-7'>
                        {linkItem?.title}
                    </span>
                </a>
            </li>
        )
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    index: PropTypes.number,
    linkItem: PropTypes.object
};

HeaderLink.propTypes = propTypes;

export default HeaderLink;
